import { ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewContainerRef } from "@angular/core";
import { DrsDenyComponent } from "./drs-deny.component";


class DrsDenyForm implements com.ts.mobile.sdk.UIFormSession{
    clientContext: object;
    actionContext: object;
    formId: string;
    payload: object;
    correlationId: string;

    submitHandler: any;
    submitBlock: (payload: object) => void;
    resolver: ComponentFactoryResolver;
    viewContainerRef: ViewContainerRef;
    drsDenyComponentRef: ComponentRef<DrsDenyComponent>;

    constructor(formId: string, payload: object) {
        console.log('Inside DrsDenyForm constructor');
        this.formId = formId;
        this.payload = payload;
        this.correlationId = payload['correlation_id'];
    }

    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
        console.log('DrsDenyForm session started: ' + this.formId);
        this.clientContext = clientContext;
        this.actionContext = actionContext;
        this.resolver = (clientContext as any).resolver;
        this.viewContainerRef = (clientContext as any).viewContainerRef;
      }

      endSession(): void {
        console.log('DrsDenyForm session ended: ' + this.formId);
      }

      promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
        console.log('DrsDenyForm session Input: ' + this.formId);
        const self = this;
        self.viewContainerRef.clear();
        const factory: ComponentFactory<DrsDenyComponent> =
        self.resolver.resolveComponentFactory(DrsDenyComponent);

        self.drsDenyComponentRef = self.viewContainerRef.createComponent(factory);
        self.drsDenyComponentRef.instance.onCloseLinkSubmit = self.onCloseSubmit.bind(self);
        self.drsDenyComponentRef.instance.correlationId = self.correlationId;

        return new Promise((resolve, reject) => {
          self.submitBlock = (payload: object) => {
            try {
              resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest({}));
              console.log('DrsDenyForm createFormInputSubmissionRequest SUCCESS payload: ', payload);
              self.submitBlock = null;
            } catch (e) {
              console.log('DrsDenyForm createFormInputSubmissionRequest ERROR payload: ', payload);
              console.error(e);
            }
          };
        });
      }

      onContinue(payload: object): void {
        console.log('DrsDenyForm SuccessTs onContinue for ' + this.formId + ' payload:', payload);
      }

      onError(payload: object): void {
        console.log('DrsDenyForm SuccessTs onError for ' + this.formId + ' payload:', payload);
      }

      private onCloseSubmit() {
        this.returnToClientApplicationWithError("access_denied","access_denied")
      }

      returnToClientApplicationWithError(error, errorDescription) {
        const url = this.clientContext['cookieService'].get('redirect_uri');
        console.log('redirect_uri : ', url);

        let state = this.clientContext['cookieService'].get('state');
        console.log('state : ', state);
        let appendChar = '?';
        if (url.includes('?'))
        {
          appendChar = '&';
        }
        window.location.href = url + appendChar + 'error=' + error
          + '&error_description=' +  errorDescription
          + '&lang=' + this.clientContext['cookieService'].get('lang')
          + '&state=' + state;
        return;

  }
}

export default DrsDenyForm;
